import { useFormikContext } from "formik";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";

import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { IconContext } from "react-icons/lib";

export const EnterNewPasswordSubmission = ({ props }) => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call
    let statusMessage = "";

    const { showPassword, setShowPassword } = props

    if (status?.error === true) {
        statusMessage = (
            <p className="text-danger">Error with resetting password</p>
        );
    } else if (status?.error === false) {
        statusMessage = (
            <p className="text-success">Successfully updated password</p>
        );
    } else {
        statusMessage = "";
    }

    return (
        <>
            <Row>{statusMessage}</Row>
            {(status === undefined || status?.error === true) && (
                <>
                    <Col className="d-flex justify-content-start">
                        <p>
                            Password Requirements:<br></br>
                            - Password minimum length is 8 characters.<br></br>
                            - Password must include one lowercase letter.<br></br>
                            - Password must include one uppercase letter.<br></br>
                            - Password must include a number.<br></br>
                            - Password must include a special character.
                        </p>
                    </Col>
                    <Row>
                        <Col>
                            <Button
                                className="btn btn-primary"
                                type="submit"
                                disabled={isSubmitting}
                            >
                                Submit
                            </Button>
                        </Col>
                        <Col
                            className="d-flex justify-content-end">
                            <Button
                                id="check"
                                style={{ backgroundColor: "white", outline: "none" }}
                                onClick={() =>
                                    props.setShowPassword((prev) => !prev)
                                }>
                                <IconContext.Provider
                                    value={{ color: "blue", size: '20px' }}>
                                    {showPassword ?
                                        <FaEyeSlash />
                                        :
                                        <FaEye />
                                    }
                                </IconContext.Provider>
                            </Button>
                        </Col>
                    </Row>
                    {/* <Row className="mt-2">
                        <Col xs={8} className="d-flex justify-content-start">
                            <p>
                                Remember your password?{" "}
                            </p>
                        </Col>
                        <Col xs={4} className="d-flex justify-content-end">
                            <Link to="/signin">Sign in</Link>
                        </Col>
                    </Row> */}
                </>
            )}
        </>
    );
};
